import { useMemo } from "react";

import { useFeature } from "byzantine";
import { useLocalization } from "@fluent/react";

import type { SidebarOptionItem } from "../sidebar.types";

/**
 * Hook that computes AOIOB (Account Opening in Online Banking)
 * sub-items.
 *
 * Internalizes `useFeature` and `useLocalization`. Returns a
 * zero-or-one element array so it can be spread uniformly with
 * other option sources.
 */
export const useAOIOBOptions = (): SidebarOptionItem[] => {
  const { featureEnabled } = useFeature();
  const { l10n } = useLocalization();

  return useMemo((): SidebarOptionItem[] => {
    if (!featureEnabled("aoiob")) {
      return [];
    }

    return [
      {
        type: "aoiob",
        title: l10n.getString(
          "tools-menu-open-an-account",
          {},
          "Open an account"
        ),
      },
    ];
  }, [featureEnabled, l10n]);
};
